export default "__VITE_ASSET__a97db235__"